import * as React from 'react'
import classNames from 'classnames'

import style from './style.scss'

type Props = {
  children: React.ReactNode
  className?: string
}

HeadlineFour.defaultProps = {
  className: '',
}

function HeadlineFour(props: Props) {
  const { className, children } = props
  return <h4 className={classNames(style.wrapper, className)}>{children}</h4>
}

export default HeadlineFour
